import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { FormGroup } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import _ from "lodash";
import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables";

// Css
import "../../assets/css/grantaccesstables.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    recipientNameHeader: "Recipient Name",
    recipientEmailHeader: "Recipient Email",
    selectRecipientBtn: "Select Recipient",
    editRecipientBtn: "Edit Recipient",
    popUpTitle: "Recipients",
    selectRecipientsLabel: "Select Recipients",
    nameHeader: "Name",
    emailHeader: "Email",
    recipientListLabel: "Recipient List",
    okBtn: "OK",
    cancelBtn: "Cancel",
    noDataTitle: "There is no data to display",
    searchPlaceholder: "Search",
    selectRecipient: "Please select at least one recipient",
  },
  ja: {
    recipientNameHeader: "メンバー名",
    recipientEmailHeader: "メンバーEmail",
    selectRecipientBtn: "メンバー選択",
    editRecipientBtn: "メンバー編集",
    popUpTitle: "メンバー",
    selectRecipientsLabel: "メンバー選択",
    nameHeader: "名前",
    emailHeader: "Eメール",
    recipientListLabel: "メンバーリスト",
    okBtn: "OK",
    cancelBtn: "キャンセル",
    noDataTitle: "表示するデータがありません。",
    searchPlaceholder: "検索",
    selectRecipient: "少なくとも 1 人の受信者を選択してください",
  },
  es: {
    recipientNameHeader: "Nombre del Destinatario",
    recipientEmailHeader: "Correo Electrónico del Destinatario",
    selectRecipientBtn: "Seleccionar Destinatario",
    editRecipientBtn: "Editar Destinatario",
    popUpTitle: "Destinatarios",
    selectRecipientsLabel: "Seleccionar Destinatarios",
    nameHeader: "Nombre",
    emailHeader: "Correo Electrónico",
    recipientListLabel: "Lista de Destinatarios",
    okBtn: "OK",
    cancelBtn: "Cancelar",
    noDataTitle: "No hay datos para mostrar",
    searchPlaceholder: "Buscar",
    selectRecipient: "Por favor seleccione al menos un destinatario",
  },
});

class RecipientsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
      recipientListArray: [],
      addedRecipients: [],
      selectedRecipients: [],
      _notificationSystem: null,
    };

    this.handleInsertButtonClick = this.handleInsertButtonClick.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.createCustomSearchFieldForm = this.createCustomSearchFieldForm.bind(
      this
    );
    this.renderSelectRecipient = this.renderSelectRecipient.bind(this);
    this.unselectRecipient = this.unselectRecipient.bind(this);
    this.handlePopupSubmit = this.handlePopupSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillReceiveProps(nextProps) {
    const selectedRecipients = [];
    const addedRecipientArray = [];

    for (var i = 0; i < nextProps.selectedRecipients.length; i++) {
      const eachSelectedRecipient = nextProps.selectedRecipients[i];

      selectedRecipients.push(eachSelectedRecipient);
      addedRecipientArray.push(eachSelectedRecipient);
    }

    this.setState({
      selectedRecipients: selectedRecipients,
      addedRecipients: addedRecipientArray,
    });
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  createCustomInsertButton = (onClick) => {
    return (
      <button
        className="selectRecipientBtn"
        onClick={() => this.handleInsertButtonClick(onClick)}
      >
        <i className="fa fa-user" />{" "}
        {this.state.selectedRecipients.length > 0
          ? localizationStrings.editRecipientBtn
          : localizationStrings.selectRecipientBtn}
      </button>
    );
  };

  handleInsertButtonClick() {
    const allRecipients = [];
    const addedRecipientsEmail = [];
    const selectedRecipients = [];

    // console.log(this.props.recipientList);

    for (var i = 0; i < this.state.addedRecipients.length; i++) {
      const eachAddedRecipientEmail = this.state.addedRecipients[i].userEmail;

      addedRecipientsEmail.push(eachAddedRecipientEmail);
    }

    for (var a = 0; a < this.props.recipientList.length; a++) {
      const eachRecipient = this.props.recipientList[a];

      if (!addedRecipientsEmail.includes(eachRecipient.userEmail)) {
        allRecipients.push(eachRecipient);
      }
    }

    for (var b = 0; b < this.props.selectedRecipients.length; b++) {
      const eachSelectedRecipient = this.props.selectedRecipients[b];

      selectedRecipients.push(eachSelectedRecipient);
    }

    this.setState({
      showPopup: true,
      recipientListArray: allRecipients,
      selectedRecipients: selectedRecipients,
    });
  }

  handlePopupClose() {
    const addedRecipientArray = [];

    for (var i = 0; i < this.state.selectedRecipients.length; i++) {
      const eachSelectedRecipient = this.state.selectedRecipients[i];

      addedRecipientArray.push(eachSelectedRecipient);
    }

    this.setState({
      showPopup: false,
      addedRecipients: addedRecipientArray,
    });
  }

  createCustomSearchFieldForm() {
    return (
      <SearchField
        // style={{ color: "blue" }}
        className="formSearchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }

  renderSelectRecipient(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allRecipientsArrayList = this.state.recipientListArray;
            const addedRecipientsArrayList = this.state.addedRecipients;

            addedRecipientsArrayList.push(row);
            allRecipientsArrayList.splice(
              allRecipientsArrayList.indexOf(row),
              1
            );
            this.setState({
              recipientListArray: allRecipientsArrayList,
              addedRecipients: addedRecipientsArrayList,
            });
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  unselectRecipient(cell, row) {
    return (
      <div>
        <button
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allRecipientsArrayList = this.state.recipientListArray;
            const addedRecipientsArrayList = this.state.addedRecipients;

            allRecipientsArrayList.push(row);
            addedRecipientsArrayList.splice(
              addedRecipientsArrayList.indexOf(row),
              1
            );

            this.setState({
              recipientListArray: allRecipientsArrayList,
              addedRecipients: addedRecipientsArrayList,
            });
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  handlePopupSubmit() {
    if (this.state.addedRecipients.length <= 0) {
      this.showNotification(
        `${localizationStrings.selectRecipient}`,
        "error",
        5
      );
      return;
    }

    const confirmedRecipients = [];

    for (var i = 0; i < this.state.addedRecipients.length; i++) {
      const eachAddedRecipient = this.state.addedRecipients[i];

      confirmedRecipients.push(eachAddedRecipient);
    }

    this.props.dataCallBack(confirmedRecipients);

    this.setState({
      showPopup: false,
      selectedRecipients: confirmedRecipients,
    });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }

    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        {/* {this.props.visible && (
          <BootstrapTable data={this.props.selectedRecipients} bordered={false}>
            <TableHeaderColumn
              dataField="userName"
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              Recipient Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="userEmail"
              isKey={true}
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              Recipient Email
            </TableHeaderColumn>
          </BootstrapTable>
        )} */}
        {this.props.visible && (
          <BootstrapTable
            className="grantAccessSelectTable"
            data={this.state.selectedRecipients}
            bordered={false}
            pagination
            options={{
              sizePerPage: 5,
              hideSizePerPage: true,
              insertBtn: this.createCustomInsertButton,
              noDataText: localizationStrings.noDataTitle,
            }}
            insertRow
            tableStyle={{ border: "4px solid #3C3E41", borderRadius: "12px" }}
          >
            <TableHeaderColumn
              dataField="userName"
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              {localizationStrings.recipientNameHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="userEmail"
              isKey={true}
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              {localizationStrings.recipientEmailHeader}
            </TableHeaderColumn>
          </BootstrapTable>
        )}
        {/* //! Popup for Select Recipient Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.popUpTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <div className="selectMembersTable">
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.selectRecipientsLabel}
              </ControlLabel>
              <BootstrapTable
                data={this.state.recipientListArray}
                bordered={false}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  searchField: this.createCustomSearchFieldForm,
                  defaultSortName: "userName", // default sort column name
                  defaultSortOrder: "asc", // default sort order
                  noDataText: localizationStrings.noDataTitle,
                }}
                search
              >
                <TableHeaderColumn
                  // dataSort
                  dataField="userName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="userEmail"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.emailHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={this.renderSelectRecipient}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                ></TableHeaderColumn>
              </BootstrapTable>
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.recipientListLabel}
              </ControlLabel>
              <BootstrapTable
                data={this.state.addedRecipients}
                bordered={false}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  noDataText: localizationStrings.noDataTitle,
                }}
              >
                <TableHeaderColumn
                  // dataSort
                  dataField="userName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="userEmail"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.emailHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={this.unselectRecipient}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                ></TableHeaderColumn>
              </BootstrapTable>
            </div>
            <FormGroup style={{ display: "flex" }}>
              <Button
                style={{ marginRight: "10px" }}
                onClick={this.handlePopupSubmit}
              >
                {localizationStrings.okBtn}
              </Button>
              <Button
                style={{ marginLeft: "10px" }}
                onClick={this.handlePopupClose}
              >
                {localizationStrings.cancelBtn}
              </Button>
            </FormGroup>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default RecipientsTable;
